import styled from "styled-components"
import { device } from "../../theme/device"

export const FavouriteCardContainer = styled.div`
  /* display: flex; */
  width: 100%;
  height: 100%;
  min-width: 600px;
  min-height: 600px;
  font-family: NotoSans-Regular;
  font-weight: 200;
  opacity: ${props => props.visible};
  transition: opacity 0.2s ease;
  position: relative;
  pointer-events: initial;
  background-color: #76948f;
`

export const FloorplanHolder = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  width: 70%;
  height: 100%;
  cursor: zoom-in;
  background-color: #e8e8e8;
  height: 100%;
  overflow: hidden;
`

export const ThreeSixtyWrapper = styled.div`
  top: 0;
  z-index: 999999999999999;
  position: absolute;
  width: 100%;

  cursor: zoom-in;
  height: 100%;
  overflow: hidden;
`

export const InfoHolder = styled.div`
  height: 100%;
  flex-direction: column;
  left: 70%;
  position: absolute;
  width: 30%;
  position: relative;
`

export const TitleHolder = styled.div`
  position: absolute;
  left: 0%;
  width: 100%;
  height: 20%;
  display: flex;
  justify-content: space-between;
  padding: 1em;
  background-color: #d1e7e6;
`

export const Level = styled.div`
  padding-left: 0.8em;
  font-family: NewParisKingSize-Regular;
  font-size: 5vw;
  font-weight: 100;
  color: #f5f5f5;
  position: relative;
  &:after {
    content: "LEVEL";
    font-size: 0.3em;
    color: #767474;
    font-family: AzoSans-Regular;
    position: absolute;
    top: 1em;
    left: 0;
    z-index: 1;
  }
`
export const ApartID = styled.div`
  padding-left: 0.2em;
  font-family: NewParisKingSize-Regular;
  font-size: 2vw;
  font-weight: 100;
  color: #536866;
  position: relative;
  display: flex;
  align-items: flex-end;
`
export const InfoContent = styled.div`
  position: absolute;
  left: 0;
  top: 20%;
  width: 100%;
  height: 40%;
  display: flex;
  flex-direction: column;
  padding: 1em;
  background-color: #76948f;
`
export const Dimensions = styled.div`
  background-image: ${({ image }) => `url(${image})`};
  background-position: left center;
  background-size: contain;
  background-repeat: no-repeat;
  height: 100%;
  max-height: 350px;

  mix-blend-mode: screen;
`

export const Content = styled.div`
  position: absolute;
  top: 60%;
  left: 0;
  width: 100%;
  height: 36%;
  background-color: #76948f;
  /* display: flex;
  flex: 1.3;
  padding: 1em;
  */
`

export const Compas = styled.div`
  /* border: red solid 1px; */
  position: absolute;
  left: 60%;
  width: 40%;
  height: 100%;
  background-image: ${({ image }) => `url(${image})`};
  background-position: center;
  background-size: 50% auto;
  background-repeat: no-repeat;
`
export const BlockID = styled.div`
  font-family: AzoSans-Regular;
  font-size: 1vw;
  font-weight: 100;
  color: #d0d1d0;
  position: relative;
  display: flex;
  margin-bottom: 0.5em;
`
export const RoomType = styled.div`
  padding-left: 0.2em;
  font-family: OuterSans-Regular;
  font-size: 1vw;
  font-weight: 400;
  color: #d0d1d0;
  position: relative;
  display: flex;
  margin-bottom: 0.8em;
`
export const DimsHead = styled.div`
  font-family: AzoSans-Regular;
  font-size: 0.9vw;
  font-weight: 100;
  color: #a8c6cb;
  position: relative;
  display: flex;
  margin-bottom: 0.2em;
`
export const DimsContent = styled.img`
  width: 100%;
`

export const ElevationHolder = styled.div`
  position: absolute;
  width: 60%;
  height: 100%;
  svg {
    left: 0;
    padding: 1em;
    position: absolute;
    top: 0;
    height: 100%;
  }
`
export const ButtonHolder = styled.div`
  position: absolute;
  width: 100%;
  height: 6%;
  bottom: 0;
  display: flex;
  justify-content: center;
  align-items: center;
`
export const Button = styled.button`
  height: 40px;
  cursor: pointer;
  flex: 1;
  padding: auto;
  font-family: AzoSans-Regular;
  font-size: 14px;
  text-transform: uppercase;
  text-align: center;
  color: white;
  background-color: ${({ color }) => color};

  opacity: ${props => (props.down ? 0.6 : 1)};
  border: none;
  outline: none;
`
export const BookmarkHolder = styled.div`
  position: absolute;
  z-index: 1;
  right: 1vw;
  height: 50px;
  width: 50px;
  cursor: pointer;
`
